module.exports = __webpack_public_path__ + "img/certification.6e94ec77.png";